import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    size?: number;
    color?: string;
};

const BackArrowIcon = ({ size = 80, color = 'currentColor', ...props }: Props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 80 80" fill="none" {...props}>
            <path d="M17 33H51C57.6274 33 63 38.3726 63 45V45C63 51.6274 57.6274 57 51 57H31M17 33L26 42M17 33L26 24" stroke={color} strokeWidth="2.4" />
        </svg>
    );
};

export default BackArrowIcon;
